import { render } from "./BlockFormModal.vue?vue&type=template&id=20a80e86&scoped=true"
import script from "./BlockFormModal.vue?vue&type=script&lang=js"
export * from "./BlockFormModal.vue?vue&type=script&lang=js"

import "./BlockFormModal.vue?vue&type=style&index=0&id=20a80e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a80e86"]])

export default __exports__